import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { auth } from '../firebase-auth';
import { ADMIN_UID } from './admin-config';

const AuthContext = createContext({
    currentUser: null,
    authLoading: true,
    isAuthenticated: false,
    isAdmin: false
});

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(() => auth.currentUser);
    const [authLoading, setAuthLoading] = useState(() => !auth.currentUser);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setCurrentUser(user);
            setAuthLoading(false);
        });

        return unsubscribe;
    }, []);

    const value = useMemo(() => ({
        currentUser,
        authLoading,
        isAuthenticated: Boolean(currentUser),
        isAdmin: currentUser?.uid === ADMIN_UID
    }), [currentUser, authLoading]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
